import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/membershipLengthSagas";

const MemberStatusFIlter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.membershipLengthByAgreement.filters.member_statuses);
  const selectedOption = useSelector(
    (state) => state.membershipLengthByAgreement.selectedFilters.member_status
  );

  return (
    <div className="select-box" style={{ width: "190px" }}>
      <p>Members Status</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOption}
        includeFilter={false}
        onSelectChange={(data) => dispatch(actionCreators.updateFilters({ member_status: data }))}
      />
    </div>
  );
};

export default MemberStatusFIlter;
